// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"c09b7f56571f0e59d299","339":"c315785ec851d1863ad5"}[chunkId] + ".js";
};